 <div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Upload spreadsheet to create asset users</mat-card-title>
    <button
      mat-fab
      (click)="downLoadFile()"
      [disabled]="!isAdminGroupUser"
      [ngClass]="
        isAdminGroupUser
          ? 'mat-mini-fab mat-accent'
          : 'mat-mini-fab mat-button-disabled'
      "
      color="accent"
      style="
        position: absolute;
        right: 20px;
        top: 8px;
        width: 35px;
        height: 35px;
      "
      matTooltip="Download Sample File"
    >
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size: 30px">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <div class="col-md-12 form-group">
        <div class="instruction-box">
          <ul class="instruction-list">
            <li>
              Upload spreadsheet to create asset users;
              <span class="highlight">maximum 250 records</span> per upload.
            </li>
            <li>
              Only the <span class="highlight">first sheet </span>will be
              processed; reference sheets are for guidance only.
            </li>
            <li>
              <span class="highlight">Do not</span> rename the sheet; use only
              the <span class="highlight">first sheet</span> to enter asset user data.
            </li>
            <li>
              <span class="highlight">Do not </span>modify column names; always
              download and use the
              <span class="highlight">latest sample </span> file.
            </li>
            <li>
              Use only values from the
              <span class="highlight">sample</span> file for
              <span class="highlight">user's status</span>; others will be
              rejected.
            </li>
             <li>
                Only <span class="highlight">lowercase emails</span> with domain
                <span class="highlight">tsiplc.com</span> are allowed.
              </li>
            <li>
              If reference data is missing, contact the system administrator.
            </li>
            <li>
              Click <span class="highlight">Download</span> to get the sample
              format. A result file will be downloaded after upload, showing
              success/failure.
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group">
          <input
            type="file"
            class="form-control"
            [disabled]="!isAdminGroupUser"
            (change)="uploadedFile($event)"
            placeholder="Upload file"
          />
        </div>
      </div>
      <div
        *ngIf="isLoaderResult"
        style="
          display: flex;
          justify-content: content;
          align-items: center;
          position: absolute;
          top: 40%;
          left: 35%;
        "
      >
        <mat-spinner color="warn"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>
